import React from "react";

const LogoRedeOkayVersion2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={78}
    height={56}
    fill="none"
    {...props}
  >
    <circle
      cx={18.837}
      cy={20.232}
      r={14.837}
      stroke="#0105DC"
      strokeWidth={8}
    />
    <rect
      width={8.682}
      height={50.188}
      x={37.984}
      y={17.704}
      fill="#0105DC"
      rx={4.341}
      transform="rotate(-40.266 37.984 17.704)"
    />
    <rect
      width={8.682}
      height={25.44}
      x={55.954}
      fill="#0105DC"
      rx={4.341}
      transform="rotate(45.758 55.954 0)"
    />
    <rect
      width={8.682}
      height={37.674}
      x={35.503}
      y={1.395}
      fill="#FFE900"
      fillOpacity={0.8}
      rx={4.341}
    />
  </svg>
);

export default LogoRedeOkayVersion2;
